/**
 * DevExtreme (esm/__internal/viz/core/data_source.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { noop } from "../../../core/utils/common";
import DataHelperMixin from "../../../data_helper";
const {
  postCtor: postCtor
} = DataHelperMixin;
let name;
const members = {
  _dataSourceLoadErrorHandler() {
    this._dataSourceChangedHandler();
  },
  _dataSourceOptions: () => ({
    paginate: false
  }),
  _updateDataSource() {
    this._refreshDataSource();
    if (!this.option("dataSource")) {
      this._dataSourceChangedHandler();
    }
  },
  _dataIsLoaded() {
    return !this._dataSource || this._dataSource.isLoaded();
  },
  _dataSourceItems() {
    var _this$_dataSource;
    return null === (_this$_dataSource = this._dataSource) || void 0 === _this$_dataSource ? void 0 : _this$_dataSource.items();
  }
};
for (name in DataHelperMixin) {
  if ("postCtor" === name) {
    continue;
  }
  members[name] = DataHelperMixin[name];
}
export const plugin = {
  name: "data_source",
  init() {
    postCtor.call(this);
  },
  dispose: noop,
  members: members
};